<template>
  <v-container>
    <v-row justify="center">
      <v-card v-if="this.editedItem.id" max-width="600" class="ma-5">
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.name"
                    label="ご担当者"
                    :rules="[v => !!v || '入力してください']"
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.insurance_name"
                    label="健保名"
                    :rules="[v => !!v || '入力してください']"
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="email"
                    v-model="editedItem.email"
                    label="メールアドレス"
                    :rules="[v => !!v || '入力してください']"
                    required
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="tel"
                    v-model="editedItem.tel"
                    label="電話番号"
                    :rules="[v => !!v || '入力してください']"
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="editedItem.address"
                    label="ご住所"
                    :rules="[v => !!v || '入力してください']"
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <v-select
                    label="請求書の発送方法"
                    :items="['データ', '郵送']"
                    v-model="editedItem.bill_type"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editedItem.login_id"
                    label="ログインID"
                    :rules="loginIdRules"
                    :append-outer-icon="passedLoginId ? 'mdi-check' : 'mdi-alert-circle-outline'"
                    counter
                    required
                    @input="checkLoginId"
                  />
                  <span>英数8文字以上</span>
                </v-col>
                <v-col cols="12" md="6">
                  <v-switch
                    v-model="changePassword"
                    label="パスワードを変更する"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-if="changePassword"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    v-model="editedItem.password"
                    label="パスワード"
                    :rules="passwordRules"
                    required
                    @click:append="showPassword = !showPassword"
                  />
                  <span v-if="changePassword">英数,記号2文字を含む8文字以上</span>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-if="changePassword"
                    :type="showRePassword ? 'text' : 'password'"
                    :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
                    v-model="editedItem.rePassword"
                    label="パスワード（再入力）"
                    :rules="rePasswordRules"
                    required
                    @click:append="showRePassword = !showRePassword"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="save">更新</v-btn>
        </v-card-actions>
      </v-card>
      <v-container v-else class="pa-5">
        <v-row justify="center" class="ma-5 pa-5">
          <v-progress-circular
            indeterminate
            color="primary"
            class="ma-5"
          />
        </v-row>
      </v-container>

      <v-dialog v-model="dialog" max-width="300">
        <v-card>
          <v-card-title>更新完了</v-card-title>
          <v-card-text>
            <p>更新しました。</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey darken-1" text @click="dialog = false">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Account',

  data: () => ({
    dialog: false,
    formValid: true,
    editedItem: {},
    changePassword: false,
    showPassword: false,
    showRePassword: false,
    passedLoginId: true
  }),
  computed: {
    loginIdRules() {
      return [
        (v) => !!v || '入力してください',
        /* (v) => (v && v.length >= 8) || '8文字以上', */
        (v) => (v && this.passedLoginId === true) || 'このIDは使用できません',
      ];
    },
    passwordRules() {
      // 英数記号を含む
      const re1 = /^(?=.*?[a-z])(?=.*?\d)(?=.*?[!-/:-@[-`{-~])[!-~"']{8,240}$/i;
      // 記号を2個含む
      const re2 = /([!-/:-@[-`{-~][!-~]*){2}/i;
      return [
        (v) => !!v || '入力してください',
        (v) => re1.test(v) || 'パスワード条件不足',
        (v) => re2.test(v) || 'パスワード条件不足'
      ];
    },
    rePasswordRules() {
      return [(v) => (!!v && v) === this.editedItem.password || 'パスワード不一致'];
    }
  },
  mounted() {
    if (this.$store.state.loggedIn === false) {
      this.$store.commit('setAfterLoginPath', '/account');
      this.$router.push('/');
    } else {
      this.$store.dispatch('getUserItem').then(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.$store.state.userItem));
      });
    }
  },
  methods: {
    checkLoginId() {
      this.passedLoginId = false;
      this.$store.dispatch('checkUpdateLoginId', { login_id: this.editedItem.login_id })
        .then(() => {
          this.passedLoginId = true;
          this.$refs.form.validate();
        });
    },
    save() {
      if (this.$refs.form.validate() === false) {
        return;
      }
      this.editedItem.change_password = this.changePassword;
      this.$store.dispatch('putUserItem', this.editedItem)
        .then(() => {
          this.dialog = true;
        })
        .catch(() => {
          alert('エラー：更新できませんでした。');
        });
    }
  }
};
</script>
